import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { StickyNav } from './components/StickyNav';
import { SiteFooter } from './components/SiteFooter';
import { ScrollToTop } from './components/ScrollToTop';
import { Home } from './pages/Home';
import { Why } from './pages/Why';
import { WhyViridia } from './pages/WhyViridia';
import { Services } from './pages/Services';
import { BookPage } from './pages/BookPage';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2mluawsf5bxuv">
      <ScrollToTop data-id="element-1" data-mp="2mmcc83go129n" />
      <div className="flex min-h-screen w-full flex-col bg-ink-900 font-sans text-white" data-id="element-2" data-mp="2mmvob3jmwwfr">
        <StickyNav data-id="element-3" data-mp="31bs27h8dh3oa" />
        <main className="flex-1" data-id="element-4" data-mp="31c9vq63nh3si">
          <Routes data-id="element-5" data-mp="31cjk5p91r2w3">
            <Route path="/" element={<Home data-id="element-7" data-mp="2wiywor52xrb5" />} data-id="element-6" data-mp="2wjgqlh49rtfw" />
            <Route path="/why" element={<Why data-id="element-9" data-mp="2wi5qbra193tj" />} data-id="element-8" data-mp="2wip6b2g4hi4x" />
            <Route path="/why-viridia" element={<WhyViridia data-id="element-11" data-mp="28t4j27cxrypu" />} data-id="element-10" data-mp="28tw5osok2m3z" />
            <Route path="/services" element={<Services data-id="element-13" data-mp="23vune9yyeqtk" />} data-id="element-12" data-mp="28sbe9bxjfjac" />
            <Route path="/book" element={<BookPage data-id="element-15" data-mp="23t8heerpojdg" />} data-id="element-14" data-mp="23ujkecdc1n3i" />
            <Route path="/how-it-works" element={<Navigate to="/why" replace data-id="element-17" data-mp="3iiwfuqnezm4a" />} data-id="element-16" data-mp="3ijxsv0nzqion" />
            <Route path="/who-its-for" element={<Navigate to="/why" replace data-id="element-19" data-mp="3ml17jjuay8oa" />} data-id="element-18" data-mp="3ii4s22026sok" />
            <Route path="/about" element={<Navigate to="/why-viridia" replace data-id="element-21" data-mp="3rc9ca2kot5v4" />} data-id="element-20" data-mp="3mjq3rk0ux0x6" />
            <Route path="*" element={<Navigate to="/" replace data-id="element-23" data-mp="3reccfffk0fdk" />} data-id="element-22" data-mp="3rcsy3udgkeef" />
          </Routes>
        </main>
        <SiteFooter data-id="element-24" data-mp="5gfrc0u9uwx" />
      </div>
    </BrowserRouter>;
}